import * as swcHelpers from '@swc/helpers';
import { SUBSCRIPTIONS_CHANNEL_KEY } from '../constants.js';
import { getDiscount } from './get-discount.js';
import { getDiscountDescription } from './get-discount-description.js';
import { getPrice } from './get-price.js';

const mapToPurchaseTypePrices = (prices, locale, pricePerUnit, pricePerUnitSubscription)=>{
    if (!prices || prices.length === 0) {
        return undefined;
    }
    // The first array item is always the single purchase price
    const [rawSinglePurchasePrice, ...rawPrices] = prices;
    if (!rawSinglePurchasePrice) {
        return undefined;
    }
    const rawSubscriptionPurchasePrice = rawPrices.find((price)=>{
        var ref, ref1;
        return (price === null || price === void 0 ? void 0 : (ref = price.channel) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) === SUBSCRIPTIONS_CHANNEL_KEY;
    });
    const singlePurchasePrice = getPrice([
        rawSinglePurchasePrice
    ]);
    const subscriptionPurchasePrice = rawSubscriptionPurchasePrice ? getPrice([
        rawSubscriptionPurchasePrice
    ]) : undefined;
    if (!singlePurchasePrice) {
        return undefined;
    }
    return {
        'single-purchase': swcHelpers.objectSpread({}, singlePurchasePrice, {
            discountInfo: {
                discountDescription: getDiscountDescription([
                    rawSinglePurchasePrice
                ], locale),
                discountBadge: getDiscount([
                    rawSinglePurchasePrice
                ], locale)
            },
            unitPrice: pricePerUnit,
            isCentAmount: true
        }),
        'subscription-purchase': subscriptionPurchasePrice && rawSubscriptionPurchasePrice && swcHelpers.objectSpread({}, subscriptionPurchasePrice, {
            discountInfo: {
                discountDescription: getDiscountDescription([
                    rawSubscriptionPurchasePrice
                ], locale),
                discountBadge: getDiscount([
                    rawSubscriptionPurchasePrice
                ], locale)
            },
            unitPrice: pricePerUnitSubscription,
            isCentAmount: true
        })
    };
};

export { mapToPurchaseTypePrices };
//# sourceMappingURL=map-to-purchase-type-prices.js.map
